import classNames from 'classnames'

const ButtonPlus = ({ disabled, handlePlus }) => {
  return (
    <div className={classNames('counter_btn_wrapper', { disabled })} onClick={handlePlus}>
      <svg
        className="counter_btn btn_plus"
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
      >
        <path d="M7.5 1V13" stroke="#29293D" strokeWidth="2" strokeLinecap="round" />
        <path d="M1.5 7H13.5" stroke="#29293D" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </div>
  )
}

export default ButtonPlus
